<template>
    <router-view></router-view>
</template>

<script>
    export default {
        name: "RootComponent"
    }
</script>

<style scoped>

</style>